import * as React from 'react';
import copy from 'copy-to-clipboard';
import { Button, Popconfirm, message } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import * as store from '../store';
import { generateShareLink } from '../utils';

const SharePopover = () => {
  const { type } = store.useDashboardReadonlyData();
  const [shareLink, setShareLink] = React.useState<string>();

  const handleCopy = () => {
    const currentLink = generateShareLink();

    if (!currentLink) return;

    setShareLink(currentLink);
    copy(currentLink);
    message.info('Share link copied to clipboard');
  };

  return (
    <Popconfirm
      title="Share Link"
      destroyOnHidden
      placement="bottomRight"
      icon={null}
      trigger="click"
      description={
        <Button
          type="link"
          href={shareLink}
          target="_blank"
          style={{
            height: 'auto',
            whiteSpace: 'break-spaces',
            textAlign: 'left',
            wordBreak: 'break-all',
            padding: '8px 2px',
          }}
        >
          {shareLink}
        </Button>
      }
      okText="Copy to Clipboard"
      onConfirm={handleCopy}
      styles={{ root: { width: 420 } }}
    >
      <Button disabled={type === 'temp'} icon={<ShareAltOutlined />} onClick={handleCopy} />
    </Popconfirm>
  );
};

export default SharePopover;
